export const LEGACY_PATHS: Record<string, string> = {
  '/contracts/:uuid': '/contract/:uuid',
  '/quotes/:uuid': '/quote/:uuid',
  '/dashboard': '/workbench/overview',
  '/calendar': '/workbench/calendar',
  '/follow-ups': '/workbench/follow-up',
  '/tasks': '/workbench/task',
  '/attachments': '/workbench/attachment',
  '/leads': '/lead/my',
  '/customers': '/customer/my',
  '/contact': '/contact/my',
  '/opportunities': '/opportunity/my',
  '/invoice/profile': '/setting/general/invoice-profile',
  '/lead-source-analysis': '/analysis/lead-source',
  '/governance': '/analysis/governance',
  '/system-config': '/setting/general/permission',
  '/permissions': '/setting/general/permission',
  '/automation-rules': '/setting/general/automation-rule',
  '/customer-pool-configs': '/setting/customer/pool',
  '/lead-pool-configs': '/setting/lead/pool',
  '/lead-assign-rules': '/setting/lead/assign-rule',
  '/customer-limit-configs': '/setting/customer/limit',
  '/owner-limit-configs': '/setting/customer/limit',
  '/source-channels': '/setting/customer/source-channel',
  '/opportunity-pipelines': '/setting/opportunity/pipeline',
  '/opportunity-stages': '/setting/opportunity/stage',
  '/areas': '/setting/lead/area',
  '/industries': '/setting/lead/industry',
  '/contract-configs': '/setting/contract/config',
  '/contract-code-rules': '/setting/contract/code-rule',
  '/system-config/general/permissions': '/setting/general/permission',
  '/system-config/general/automation-rules': '/setting/general/automation-rule',
  '/system-config/general/workflow-approval':
    '/setting/general/workflow-approval',
  '/system-config/general/invoice-profile': '/setting/general/invoice-profile',
  '/system-config/general/dictionaries': '/setting/general/dictionary',
  '/system-config/dictionaries': '/setting/general/dictionary',
  '/system-config/lead/pool': '/setting/lead/pool',
  '/system-config/lead/assign-rules': '/setting/lead/assign-rule',
  '/system-config/lead/industries': '/setting/lead/industry',
  '/system-config/lead/areas': '/setting/lead/area',
  '/system-config/customer/pool': '/setting/customer/pool',
  '/system-config/customer/source-channels': '/setting/customer/source-channel',
  '/system-config/customer/levels': '/setting/customer/level',
  '/system-config/customer/limits': '/setting/customer/limit',
  '/system-config/opportunity/pipelines': '/setting/opportunity/pipeline',
  '/system-config/opportunity/stages': '/setting/opportunity/stage',
  '/system-config/contract/config': '/setting/contract/config',
  '/system-config/contract/code-rules': '/setting/contract/code-rule',
  '/system-config/customer-pool-configs': '/setting/customer/pool',
  '/system-config/lead-pool-configs': '/setting/lead/pool',
  '/system-config/lead-assign-rules': '/setting/lead/assign-rule',
  '/system-config/customer-limit-configs': '/setting/customer/limit',
  '/system-config/owner-limit-configs': '/setting/customer/limit',
  '/system-config/opportunity-pipelines': '/setting/opportunity/pipeline',
  '/system-config/opportunity-stages': '/setting/opportunity/stage',
  '/system-config/areas': '/setting/lead/area',
  '/system-config/source-channels': '/setting/customer/source-channel',
  '/system-config/customer-levels': '/setting/customer/level',
  '/system-config/industries': '/setting/lead/industry',
  '/system-config/contract-configs': '/setting/contract/config',
  '/system-config/contract-code-rules': '/setting/contract/code-rule',
  '/approvals': '/workbench/approval',
  '/collaboration/calendar': '/workbench/calendar',
  '/collaboration/follow-ups': '/workbench/follow-up',
  '/collaboration/tasks': '/workbench/task',
  '/collaboration/attachments': '/workbench/attachment',
  '/marketing/campaigns': '/marketing/campaign',
  '/marketing/campaigns/:uuid': '/marketing/campaign/:uuid',
  '/marketing/campaigns/:uuid/members': '/marketing/campaign/:uuid/member',
  '/marketing/campaigns/:uuid/analysis': '/marketing/campaign/:uuid/analysis',
  '/leads/my': '/lead/my',
  '/leads/team': '/lead/team',
  '/leads/collab': '/lead/collab',
  '/leads/pool': '/lead/pool',
  '/leads/all': '/lead/all',
  '/leads/imported': '/lead/imported',
  '/leads/import-conflicts': '/lead/import-conflict',
  '/customers/my': '/customer/my',
  '/customers/team': '/customer/team',
  '/customers/collab': '/customer/collab',
  '/customers/pool': '/customer/pool',
  '/customers/all': '/customer/all',
  '/contacts': '/contact/my',
  '/contacts/my': '/contact/my',
  '/contacts/team': '/contact/team',
  '/contacts/collab': '/contact/collab',
  '/contacts/all': '/contact/all',
  '/opportunities/my': '/opportunity/my',
  '/opportunities/followed': '/opportunity/followed',
  '/opportunities/team': '/opportunity/team',
  '/opportunities/collab': '/opportunity/collab',
  '/opportunities/pool': '/opportunity/pool',
  '/opportunities/all': '/opportunity/all',
  '/quotes': '/quote/my',
  '/quotes/my': '/quote/my',
  '/quotes/team': '/quote/team',
  '/quotes/collab': '/quote/collab',
  '/quotes/all': '/quote/all',
  '/contracts': '/contract/my',
  '/contracts/my': '/contract/my',
  '/contracts/team': '/contract/team',
  '/contracts/collab': '/contract/collab',
  '/contracts/all': '/contract/all',
  '/receipts/list': '/receipt/list',
  '/receipts/schedules': '/receipt/schedule',
  '/receipts/schedules/:uuid': '/receipt/schedule/:uuid',
  '/invoices/list': '/invoice/list',
  '/analytics/lead-source': '/analysis/lead-source',
  '/analytics/business-map': '/analysis/business-map',
  '/analytics/governance': '/analysis/governance',
  '/settings': '/setting/general/permission',
  '/settings/general/taxonomies': '/setting/general/taxonomy',
  '/settings/general/permissions': '/setting/general/permission',
  '/settings/general/automation-rules': '/setting/general/automation-rule',
  '/settings/general/workflow-approval': '/setting/general/workflow-approval',
  '/settings/general/invoice-profile': '/setting/general/invoice-profile',
  '/settings/general/ai-model-binding': '/setting/general/ai-model-binding',
  '/settings/general/dictionaries': '/setting/general/dictionary',
  '/settings/general/dictionaries/:dictionaryCode/items':
    '/setting/general/dictionary/:dictionaryCode/item',
  '/settings/lead/pool': '/setting/lead/pool',
  '/settings/lead/assign-rules': '/setting/lead/assign-rule',
  '/settings/lead/industries': '/setting/lead/industry',
  '/settings/lead/areas': '/setting/lead/area',
  '/settings/customer/pool': '/setting/customer/pool',
  '/settings/customer/limits': '/setting/customer/limit',
  '/settings/customer/source-channels': '/setting/customer/source-channel',
  '/settings/customer/levels': '/setting/customer/level',
  '/settings/opportunity/pipelines': '/setting/opportunity/pipeline',
  '/settings/opportunity/stages': '/setting/opportunity/stage',
  '/settings/marketing/campaign-types': '/setting/marketing/campaign-type',
  '/settings/marketing/touchpoint-types': '/setting/marketing/touchpoint-type',
  '/settings/contract/config': '/setting/contract/config',
  '/settings/contract/code-rules': '/setting/contract/code-rule',
  '/': '/workbench/overview',
};
